import React from "react";

import {IRange} from "@pg-design/inputs-module";

import {isDevelopment} from "../../../app/read_rp_environment_variables";
import {OfferType} from "../../../offer/types/OfferType";
import {Currency} from "../../../types/Currency";
import {ISearchFilter} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";
import {FilterBudget} from "./FilterBudget";
import {FilterMultiCheckbox} from "./FilterMultiCheckbox";
import {FilterOfferType} from "./FilterOfferType";
import {FilterRadio} from "./FilterRadio";
import {FilterRange} from "./FilterRange";
import {FilterSelectRange} from "./FilterSelectRange";

interface IProps<TFilterValue, TValue> {
    filter: ISearchFilter<string, TFilterValue>;
    value: TValue;
    onChange: (name: string, value: TValue) => void;
    onAfterChange?: (name: string, value: TValue) => void;
    currency?: Currency;
    isInModal?: boolean;
}

export const GenericFilter = <TFilterValue, TValue>(props: IProps<TFilterValue, TValue>) => {
    if (isMultiCheckboxFilter(props)) {
        let value = props.value ? props.value : [];
        if (props.value && !Array.isArray(props.value)) {
            value = [...props.value];
        }
        return <FilterMultiCheckbox filter={props.filter} value={value} onChange={props.onChange} />;
    }

    if (isOfferTypeFilter(props)) {
        return <FilterOfferType filter={props.filter} value={props.value} onChange={props.onChange} />;
    }

    if (isRangeCheckBoxFilter(props)) {
        return <FilterSelectRange filter={props.filter} value={props.value} onChange={props.onChange} />;
    }

    if (isRangeFilter(props)) {
        return <FilterRange filter={props.filter} value={props.value} onChange={props.onChange} currency={!!props.currency} />;
    }

    if (isRadioFilter(props)) {
        return <FilterRadio filter={props.filter} value={props.value} onChange={props.onChange} />;
    }

    if (isSliderFilter(props)) {
        return <FilterBudget onChange={props.onChange} isInModal={props.isInModal} currency={props.currency} />;
    }

    if (isDevelopment) {
        throw new Error(`Unknown filter configuration passed to 'GenericFilter' - check filters configuration for: ` + props.filter.id);
    }

    return null;
};

const isMultiCheckboxFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<string | number, (string | number)[]> => {
    return props?.filter?.type === SearchFilterTypes.MULTI_CHECKBOX;
};

const isOfferTypeFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<OfferType, OfferType[]> => {
    return props.filter.type === SearchFilterTypes.OFFER_TYPE;
};

const isRangeCheckBoxFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<number, IRange<number | "">> => {
    return props.filter.type === SearchFilterTypes.SELECT_RANGE;
};

const isRangeFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<number, IRange<string>> => {
    return props.filter.type === SearchFilterTypes.RANGE;
};

const isRadioFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<string | number, (string | number)[]> => {
    return props.filter.type === SearchFilterTypes.RADIO;
};

const isSliderFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<number, IRange<string> | number | undefined> => {
    return props.filter.type === SearchFilterTypes.SLIDER;
};
import React from "react";

import {IRange} from "@pg-design/inputs-module";

import {isDevelopment} from "../../../app/read_rp_environment_variables";
import {OfferType} from "../../../offer/types/OfferType";
import {Currency} from "../../../types/Currency";
import {ISearchFilter} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";
import {FilterBudget} from "./FilterBudget";
import {FilterMultiCheckbox} from "./FilterMultiCheckbox";
import {FilterOfferType} from "./FilterOfferType";
import {FilterRadio} from "./FilterRadio";
import {FilterRange} from "./FilterRange";
import {FilterSelectRange} from "./FilterSelectRange";

interface IProps<TFilterValue, TValue> {
    filter: ISearchFilter<string, TFilterValue>;
    value: TValue;
    onChange: (name: string, value: TValue) => void;
    onAfterChange?: (name: string, value: TValue) => void;
    currency?: Currency;
    isInModal?: boolean;
}

export const GenericFilter = <TFilterValue, TValue>(props: IProps<TFilterValue, TValue>) => {
    if (isMultiCheckboxFilter(props)) {
        let value = props.value ? props.value : [];
        if (props.value && !Array.isArray(props.value)) {
            value = [...props.value];
        }
        return <FilterMultiCheckbox filter={props.filter} value={value} onChange={props.onChange} />;
    }

    if (isOfferTypeFilter(props)) {
        return <FilterOfferType filter={props.filter} value={props.value} onChange={props.onChange} />;
    }

    if (isRangeCheckBoxFilter(props)) {
        return <FilterSelectRange filter={props.filter} value={props.value} onChange={props.onChange} />;
    }

    if (isRangeFilter(props)) {
        return <FilterRange filter={props.filter} value={props.value} onChange={props.onChange} currency={!!props.currency} />;
    }

    if (isRadioFilter(props)) {
        return <FilterRadio filter={props.filter} value={props.value} onChange={props.onChange} />;
    }

    if (isSliderFilter(props)) {
        return <FilterBudget onChange={props.onChange} isInModal={props.isInModal} currency={props.currency} />;
    }

    if (isDevelopment) {
        throw new Error(`Unknown filter configuration passed to 'GenericFilter' - check filters configuration for: ` + props.filter.id);
    }

    return null;
};

const isMultiCheckboxFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<string | number, (string | number)[]> => {
    return props?.filter?.type === SearchFilterTypes.MULTI_CHECKBOX;
};

const isOfferTypeFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<OfferType, OfferType[]> => {
    return props.filter.type === SearchFilterTypes.OFFER_TYPE;
};

const isRangeCheckBoxFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<number, IRange<number | "">> => {
    return props.filter.type === SearchFilterTypes.SELECT_RANGE;
};

const isRangeFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<number, IRange<string>> => {
    return props.filter.type === SearchFilterTypes.RANGE;
};

const isRadioFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<string | number, (string | number)[]> => {
    return props.filter.type === SearchFilterTypes.RADIO;
};

const isSliderFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<number, IRange<string> | number | undefined> => {
    return props.filter.type === SearchFilterTypes.SLIDER;
};
